interface TimestampInstant {
  seconds: bigint;
  fraction: string;
}

function timestampInstant(value: string): TimestampInstant {
  const match =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(Z|([+-])(\d{2}):(\d{2}))$/.exec(
      value,
    );
  if (!match) throw new RangeError('Timestamp must include an explicit timezone offset');

  const [
    ,
    year,
    month,
    day,
    hour,
    minute,
    second,
    fraction = '',
    zone,
    sign,
    offsetHour,
    offsetMinute,
  ] = match;
  const local = new Date(0);
  local.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
  local.setUTCHours(Number(hour), Number(minute), Number(second), 0);
  const offset = zone === 'Z' ? 0 : (Number(offsetHour) * 60 + Number(offsetMinute)) * 60;
  const signedOffset = sign === '+' ? offset : sign === '-' ? -offset : 0;

  return {
    seconds: BigInt(local.getTime() / 1000 - signedOffset),
    fraction: fraction.replace(/0+$/, ''),
  };
}

/** Compare offset datetimes without rounding their fractional seconds. */
export function compareTimestampInstants(left: string, right: string): -1 | 0 | 1 {
  const leftInstant = timestampInstant(left);
  const rightInstant = timestampInstant(right);
  if (leftInstant.seconds !== rightInstant.seconds)
    return leftInstant.seconds < rightInstant.seconds ? -1 : 1;

  const width = Math.max(leftInstant.fraction.length, rightInstant.fraction.length);
  const leftFraction = leftInstant.fraction.padEnd(width, '0');
  const rightFraction = rightInstant.fraction.padEnd(width, '0');
  return leftFraction === rightFraction ? 0 : leftFraction < rightFraction ? -1 : 1;
}
